// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"15c94b31","453":"712ee9e6","455":"b1b2883d"}[chunkId] + ".chunk.js";
};